import styled from 'styled-components';
import { TKIconLongArrowRight } from 'assets/images/svgs';

const ProjectCard = ({ title, text, imageUrl }) => {
  return (
    <WrapperDiv imageUrl={imageUrl}>
      <div>
        <p className='uppercase'>
          {title}
        </p>
        <p className='text-[12px]'>{text}</p>
      </div>
      <TKIconLongArrowRight />
    </WrapperDiv>
  )
}

export default ProjectCard

const WrapperDiv = styled.div`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%), url(${(props) => props.imageUrl});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 400px;
  padding: 2rem;
  height: 260px;
  display: flex;
  flex: 1 0 auto;
  justify-content: space-between;
  align-items: end;
  color: white;
  border-radius: 10px;
  cursor: pointer;
`;